<template>
  <div class="memberManage">
    <!-- 个人扫码 -->
    <div v-if="ChannelMyStatus==1">
      <el-col :span="24" style="padding-bottom: 0px">
        <el-form :inline="true" :model="form" label-width="auto">
          <el-form-item>
            <div class="block">
              <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                @change="onPick"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-input v-model="params.agent_name" placeholder="请输入代理名称或代理账号" class="myInput"></el-input>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model="params.order_sn"
              placeholder="请输入代理订单号"
              class="myInput"
              style="width:300px"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="goon"
              icon="el-icon-search"
              @click="search()"
              style="margin-left:20px"
            ></el-button>
          </el-form-item>

          <el-form-item v-if="agent_type == '管理员'">
            <el-button
              type="goon"
              @click="revertMy()"
              style="margin-left:20px"
            >渠道扫码</el-button>
          </el-form-item>

          <el-form-item>
            <el-button
              type="goon"
              @click="exportExcel()"
              style="margin-left:20px"
            >导出excel</el-button>
          </el-form-item>

          <el-form-item class="left">
            <div>
              当前扫码充值金额：
              <span>{{amountOfMoney}}元</span>
            </div>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span="24" style="margin-top:20px">
         <div class="table_title">扫码订单</div>
        <el-table :data="tableData" border style="width:100%">
          <el-table-column label="用户昵称" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.nick_name != ''">{{scope.row.nick_name}}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column label="代理账号" prop="" align="center"></el-table-column> -->

          <el-table-column label="代理名称" prop="agent_name" align="center"></el-table-column>
          <el-table-column label="订单号" prop="order_sn" align="center"></el-table-column>
          <el-table-column label="金额（元）" prop="qamount" align="center"></el-table-column>
          <el-table-column label="支付类型" prop="wxpay" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.pay_type == 'wxpay'">微信</span>
              <span v-else>支付宝</span>
            </template>
          </el-table-column>
          <el-table-column label="订单时长" prop="product_name" align="center"></el-table-column>
          <el-table-column label="充值时间" prop="complete_at" align="center"></el-table-column>
        </el-table>
      </el-col>

      <el-pagination
        background
        @size-change="handleSizeChangeOne"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange"
      ></el-pagination>

      <!--启用按钮-->
      <el-dialog title="提示" :visible.sync="useVisible" width="30%" center>
        <div class="tooltips">{{this.form.start}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="useVisible = false">取 消</el-button>
          <el-button type="primary" @click="stopRow()">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <div class v-if="ChannelMyStatus==2">
      <el-col :span="24" style="padding-bottom: 0px">
        <el-form :inline="true" :model="form" label-width="auto">
          <el-form-item>
            <div class="block">
              <el-date-picker
                v-model="value2"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                @change="onPickChannel"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-input v-model="paramsChannel.order_number" placeholder="请输入订单号" class="myInput"></el-input>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model="paramsChannel.user_id"
              placeholder="请输入用户id"
              class="myInput"
              style="width:300px"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="goon"
              icon="el-icon-search"
              @click="searchChannel()"
              style="margin-left:20px"
            ></el-button>
          </el-form-item>

          <el-form-item>
            <el-button
              type="goon"
              @click="revertChannel()"
              style="margin-left:20px"
            >个人扫码</el-button>
          </el-form-item>

          <el-form-item class="left">
            <div>
              当前扫码充值金额：
              <span>{{ sum_money }}元</span>
            </div>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span="24" style="margin-top:20px">
        <el-table :data="channelTableData" border style="width:100%">
          <el-table-column label="用户账号" prop="user_account" align="center"></el-table-column>
          <el-table-column label="订单编号" prop="order_number" align="center"></el-table-column>
          <el-table-column label="用户id" prop="user_id" align="center"></el-table-column>
          <el-table-column label="支付金额" prop="pay_amount" align="center"></el-table-column>
          <el-table-column label="产品名称" prop="product_name" align="center"></el-table-column>
          <el-table-column label="开始时间" prop="product_start_time" align="center"></el-table-column>
          <el-table-column label="结束时间" prop="end_time" align="center"></el-table-column>
        </el-table>
      </el-col>
      <!-- <el-pagination
        style="padding-bottom:20px"
        :total="count"
        @current-change="handleCurrentChangeCount"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>-->

      <el-pagination
        background
        @size-change="handleSizeChangeTwo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
        :page-size="10"
        @current-change="handleCurrentChangeCount"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import * as sysApi from "../../common/sys";
import { formatDate } from "../../common/utils";
import XLSX from 'xlsx'
import dayjs from "dayjs";
export default {
  data() {
    return {
      ChannelMyStatus: 1,
      // 个人扫码
      value1: [dayjs().add(-7, "days").format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],
      form: {
        status: "全部",
        account_number: "",
        start_time: "",
        end_time: "",
        start: "",
        agent_name: "",
        page: 1 // 页数
      },
      currentPage: 1,
      useVisible: false,
      tableData: [],
      samount: 0,
      amountOfMoney: "",
      total: 1,
      params: {
        order_sn: "", //  订单号
        agent_name: "", // 代理名称
        end_at: "", //   结束日期
        page: 1, // 默认一页
        sort: 0, // 排序
        page_size: 10,
        start_at: "", // 开始日期
        user_id: 0 //
      },
      rowId: "",

      // 渠道扫码
      value1: [dayjs().add(-7, "days").format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],
      paramsChannel: {
        end_time: "", // 结束时间
        order_number: "", // 订单号
        page: 0,
        start_time: "", // 开始时间
        user_id: "", //  用户id
        page_size: 10
      },
      channelTableData: [],
      sum_money: "", // 订单总金额
      count: 1, // 条数
      agent_type: ""
    };
  },
  created() {
    this.agent_type = localStorage.getItem("agent_type");
    this.initQuery();
    // this.initQueryChannel();
  },
  methods: {
    // 导出exe表格
    exportExcel() {
      let par = {
        end_at: this.params.end_at,
        start_at: this.params.start_at,
        agent_name: this.params.agent_name
      };
      sysApi
        .sm_order_excel(par)
        .then(res => {
          let arrNew = [];
          arrNew.push(["代理昵称","充值时间","用户昵称","订单号","支付类型","订单时长","金额（元）"])
          res.result.forEach(element => {
            let  arrNew2 = [];
            arrNew2.push(element.agent_name)
            arrNew2.push(element.complete_at)
            arrNew2.push(element.nick_name)
            arrNew2.push(element.order_sn)
            arrNew2.push(element.pay_type)
            arrNew2.push(element.product_name)
            arrNew2.push(element.qamount)
            arrNew.push(arrNew2)
          });
          const filename ='orders.xlsx'
          const ws_name = 'Sheet1'
          const wb = XLSX.utils.book_new()
          const ws = XLSX.utils.aoa_to_sheet(arrNew);
          XLSX.utils.book_append_sheet(wb, ws, ws_name) // 将数据添加到工作薄
          XLSX.writeFile(wb, filename) // 导出Exce
        })
        .catch(err => console.log("请求异常信息:" + err));
    },
    // 个人扫码
    initQuery() {
      console.log(this.params);
      sysApi
        .sm_order_list(this.params)
        .then(res => {
          console.log(res);
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          this.tableData = res.count;
          this.total = res.page;
          this.amountOfMoney = res.money.toFixed(2);
        })
        .catch(err => console.log("请求异常信息:" + err));
    },
    //  搜索
    search() {
      this.initQuery();
    },
    // 时间
    onPick(val) {
      this.params.start_at = val[0];
      this.params.end_at = val[1];

      // debugger
      this.initQuery();
    },
    //  分页
    handleCurrentChange(val) {
      this.params.page = val;
      this.initQuery();
    },
    revertMy() {
      this.ChannelMyStatus = 2;
      this.initQueryChannel();
    },
    handleSizeChangeOne(val) {
      this.params.page_size = val;
      this.initQuery();
    },

    //  渠道扫码  管理员
    initQueryChannel() {
      sysApi
        .person_order(this.paramsChannel)
        .then(res => {
          console.log(res);
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          this.channelTableData = res.result;
          this.sum_money = res.sum_money.toFixed(2);
          this.count = res.sum_page;
          console.log(res.result);
        })
        .catch(err => console.log("请求异常信息:" + err));
    },
    //  渠道扫码 分页
    handleCurrentChangeCount(val) {
      this.paramsChannel.page = val;
      this.initQueryChannel();
    },
    // 渠道扫码 选择时间
    onPickChannel(val) {
      this.paramsChannel.start_time = val[0];
      this.paramsChannel.end_time = val[1];
      this.initQueryChannel();
    },
    // 渠道扫码 查询
    searchChannel() {
      this.initQueryChannel();
    },
    // 渠道扫码 返回
    revertChannel() {
      this.ChannelMyStatus = 1;
      this.initQuery();
    },
    handleSizeChangeTwo(val) {
      this.paramsChannel.page_size = val;
      this.initQueryChannel();
    }
  }
};
</script>











<style lang="scss">
.left {
  float: right;
  font-size: 18px;
  div {
    font-size: 16px;
    color: #626262;
    span {
      color: #f14561;
      font-weight: bold;
    }
  }
}
.memberManage {
  padding: 20px;
  margin-bottom: 10px;
}
.el-form-item__label {
  text-align: left;
}
.el-button--goon.is-active,
.el-button--goon:active {
  background: #537fed;
  border-color: #537fed;
  color: #fff;
}

.el-button--goon:focus,
.el-button--goon:hover {
  background: #769dff;
  border-color: #769dff;
  color: #fff;
}
.el-button--goon {
  color: #fff;
  background-color: #6692ff;
  border-color: #6692ff;
}
.myInput {
  width: 200px;
}
</style>


